import {Snackbar} from '../snackbar';
import {newSpecPage} from '@stencil/core/testing';
import SnackbarUtils from '@/components-triggers/snackbar/snackbar-utils';

it('should inject a custom-element from a pushNotification method', async () => {
    const page = await newSpecPage({
        components: [Snackbar],
        html: '',
    });

    SnackbarUtils.pushNotification('I am a message');
    expect(page.root).not.toBe(null);
    expect(!!page.body.querySelector('joy-snackbar')).toBe(true);
});

it('should inject a custom-element from a pushNotification method with default values', async () => {
    const page = await newSpecPage({
        components: [Snackbar],
        html: '',
    });

    SnackbarUtils.pushNotification('I am a message');

    expect(page.root!.dangerousHtmlMessage).toBe('I am a message');
    expect(page.root!.duration).toBe('5000');
    expect(page.root!.level).toBe('success');
    expect(page.root!.closable).toBe(true);
});

it('should inject a custom-element from a pushNotification method with given values', async () => {
    const page = await newSpecPage({
        components: [Snackbar],
        html: '',
    });

    SnackbarUtils.pushNotification('I am a message', {
        level: 'error',
        duration: '1000',
    });

    expect(page.root!.duration).toBe('1000');
    expect(page.root!.level).toBe('error');
});

it('should inject a custom CTA to be able to trigger any action', async () => {
    const page = await newSpecPage({
        components: [Snackbar],
        html: '',
    });

    SnackbarUtils.pushNotification('I am a message', {
        level: 'error',
        duration: '1000',
    });

    expect(page.root!.duration).toBe('1000');
    expect(page.root!.level).toBe('error');
});
